import React, { PureComponent } from "react";
import MgmtLayout from "../../../../components/layouts/MgmtLayout";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { Col, Row, Card, Select, Table, DatePicker } from "antd";
import { Button } from "../../../../components";
import StorageService from "../../../../app/service/storageService";
import { CSVLink } from "react-csv";
import Moment from 'moment';
import MgmtService from "../../../../app/service/mgmtService";
import { TableSearch } from "../../../../hooks";
import AuthContext from "../../../../main/authenticationProvider";
import moment from "moment";
import ReportsService from "../../../../app/service/reportsService";


class MgmtPositions extends PureComponent {

    constructor(props) {
        super(props);

        this.auth = new AuthContext();
        this.tableSearch = new TableSearch();
        this.mgmtService = new MgmtService();
        this.reportsService = new ReportsService();
        this.timer = null;

        this.state = {
            positions: [],
            showLoading: false,
            loading: false,
            tablePageSize: 10,
            totalRegisters: 0,
            currentPage: 1,
            endDate: Moment().add(1, 'days'),
            startDate: Moment().subtract(7, 'days'),
            plate: StorageService.getItem("plateName") != null ? StorageService.getItem("plateName") : "",
            plates: [],
            clientName: ""
        }
    }

    getPlates = () => {
        this.mgmtService
            .getPlates()
            .then(response => {
                let opt = [];
                response.data.data.forEach(item => {
                    opt.push({
                        value: item.plate,
                        label: item.plate,
                        client: item.clientName
                    });
                });
                this.setState({
                    plates: opt,
                    loading: true,
                });

            })
            .catch(erros => {
                this.setState({
                    loading: false,
                });
                erros && erros.response && this.auth.verifyAuth(erros.response.status);
            })
    }

    getData = (startDate, endDate, plate, pageSize, pageIndex) => {
        this.setState({
            showLoading: true,
            totalPages: 0
        });
        let positions = [];

        this.mgmtService
            .getPositions(startDate, endDate, plate, pageSize, pageIndex)
            .then(response => {
                if (this.state.clientName == 'arlug.client') {
                    response.data.data.map((element, index) => {
                        positions.push({
                            key: index,
                            positionId: element.positionId,
                            deviceId: element.deviceId,
                            plate: element.plate,
                            date: element.date,
                            latitude: element.latitude,
                            longitude: element.longitude,
                            address: element.address,
                            ignition: element.ignition,
                            odometer: element.odometer,
                            horimeter: element.horimeter,
                            mainBattery: element.mainBattery,
                            input1: element.input1,
                            input2: element.input2,
                            output1: element.output1,
                            output2: element.output2,
                            rs232: element.rs232,
                        });
                    })
                    this.setState({
                        positions: positions,
                        totalRegisters: response.data.totalRegisters,
                        showLoading: false
                    });
                } else {
                    response.data.data.map((element, index) => {
                        positions.push({
                            key: index,
                            positionId: element.positionId,
                            deviceId: element.deviceId,
                            driverName: element.driverName,
                            plate: element.plate,
                            date: element.date,
                            latitude: element.latitude,
                            longitude: element.longitude,
                            address: element.address,
                            ignition: element.ignition,
                            odometer: element.odometer,
                            horimeter: element.horimeter,
                            direction: element.direction,
                            speed: element.speed,
                            mainBattery: element.mainBattery,
                            input1: element.input1,
                            input2: element.input2,
                            output1: element.output1,
                            output2: element.output2,
                            rs232: element.rs232,
                        });
                    })
                    this.setState({
                        positions: positions,
                        totalRegisters: response.data.totalRegisters,
                        showLoading: false
                    });
                }

            })
            .catch(erros => {
                this.setState({
                    showLoading: false
                });
                if (erros.response && erros.response.status === 401) {
                    this.auth.endSession();
                    this.props.history.push('/login');
                }
            })
    }

    delayOnChangeSearch = (plateName, currentPage) => {
        this.setState({
            showLoading: true
        });

        const startDate = typeof this.state.startDate === 'string' ? this.state.startDate : this.state.startDate.format("YYYY-MM-DD");
        const endDate = typeof this.state.endDate === 'string' ? this.state.endDate : this.state.endDate.format("YYYY-MM-DD");
        this.getData(startDate, endDate, plateName, this.state.tablePageSize, currentPage)
    }
    componentDidMount() {
        this.setState({
            loading: true,
        });
    }

    componentWillUnmount() {
        StorageService.removeItem("plateName");
    }

    render() {
        if (!this.state.loading) {
            this.getPlates();
        }

        /**
         * Data table columns and search/sort
         */

        let columns = [];
        if (this.state.clientName == "" || this.state.clientName == "everlinkteste") {
            columns = [
                {
                    title: () => {
                        return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>Position ID</div>
                    },
                    align: 'center',
                    dataIndex: 'positionId',
                },
                {
                    title: () => {
                        return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>Dispositivo</div>
                    },
                    align: 'center',
                    dataIndex: 'deviceId',
                },
                {
                    title: () => {
                        return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>Nome do Motorista</div>
                    },
                    align: 'center',
                    dataIndex: 'driverName',
                    ...this.tableSearch.getColumnSearchProps('driverName', 'Nome do Motorista')
                },
                {
                    title: () => {
                        return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>Placa</div>
                    },
                    align: 'center',
                    dataIndex: 'plate',
                },
                {
                    title: () => {
                        return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>Data</div>
                    },
                    align: 'center',
                    dataIndex: 'date',
                    sorter: (a, b) => a.date.length - b.date.length,
                    sortDirections: ['descend', 'ascend'],
                    render: (text) => moment(text).format('DD/MM/YYYY HH:mm:ss '),
                },
                {
                    title: () => {
                        return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>Latitude</div>
                    },
                    align: 'center',
                    dataIndex: 'latitude',
                    sorter: (a, b) => a.latitude - b.latitude,
                    sortDirections: ['descend', 'ascend']
                },
                {
                    title: () => {
                        return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>Longitude</div>
                    },
                    align: 'center',
                    dataIndex: 'longitude',
                    sorter: (a, b) => a.longitude - b.longitude,
                    sortDirections: ['descend', 'ascend']
                },
                {
                    title: () => {
                        return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>Endereço</div>
                    },
                    align: 'center',
                    dataIndex: 'address',
                    ...this.tableSearch.getColumnSearchProps('address', "Endereços"),

                },
                {
                    title: () => {
                        return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>Ignição</div>
                    },
                    align: 'center',
                    dataIndex: 'ignition',
                    filters: [
                        {
                            text: 'ON',
                            value: 'ON',
                        },
                        {
                            text: 'OFF',
                            value: 'OFF',
                        },
                    ],
                    onFilter: (value, record) => record.ignition.indexOf(value) === 0,
                },
                {
                    title: () => {
                        return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>Odômetro</div>
                    },
                    align: 'center',
                    dataIndex: 'odometer',
                    sorter: (a, b) => a.odometer - b.odometer,
                    sortDirections: ['descend', 'ascend']
                },
                {
                    title: () => {
                        return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>Horímetro [hh:mm]</div>
                    },
                    align: 'center',
                    dataIndex: 'horimeter',
                    sorter: (a, b) => a.horimeter - b.horimeter,
                    sortDirections: ['descend', 'ascend'],
                    render: (text) => {
                        const hours = Math.floor(text / 60);
                        const minutes = Math.floor(text % 60);
                        return `${hours}:${minutes.toString().padStart(2, '0')}`;
                    },
                },
                {
                    title: () => {
                        return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>Direção</div>
                    },
                    align: 'center',
                    dataIndex: 'direction',
                    sorter: (a, b) => a.direction - b.direction,
                    sortDirections: ['descend', 'ascend'],
                },
                {
                    title: () => {
                        return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>Velocidade</div>
                    },
                    align: 'center',
                    dataIndex: 'speed',
                    sorter: (a, b) => a.speed - b.speed,
                    sortDirections: ['descend', 'ascend']
                },
                {
                    title: () => {
                        return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>Bateria Principal</div>
                    },
                    align: 'center',
                    dataIndex: 'mainBattery',
                    sorter: (a, b) => a.mainBattery - b.mainBattery,
                    sortDirections: ['descend', 'ascend']
                },
                {
                    title: () => {
                        return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>Input 1</div>
                    },
                    align: 'center',
                    dataIndex: 'input1',
                    sorter: (a, b) => a.input1 - b.input1,
                    sortDirections: ['descend', 'ascend']
                },
                {
                    title: () => {
                        return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>Input 2</div>
                    },
                    align: 'center',
                    dataIndex: 'input2',
                    sorter: (a, b) => a.input2 - b.input2,
                    sortDirections: ['descend', 'ascend']
                },
                {
                    title: () => {
                        return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>output 1</div>
                    },
                    align: 'center',
                    dataIndex: 'output1',
                    sorter: (a, b) => a.output1 - b.output1,
                    sortDirections: ['descend', 'ascend']
                },
                {
                    title: () => {
                        return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>output 2</div>
                    },
                    align: 'center',
                    dataIndex: 'output2',
                    sorter: (a, b) => a.output2 - b.output2,
                    sortDirections: ['descend', 'ascend']
                },
                {
                    title: () => {
                        return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>RS 232</div>
                    },
                    align: 'center',
                    dataIndex: 'rs232',
                    sorter: (a, b) => a.rs232 - b.rs232,
                    sortDirections: ['descend', 'ascend']
                }
            ];
        } else {
            columns = [
                {
                    title: () => {
                        return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>Position ID</div>
                    },
                    align: 'center',
                    dataIndex: 'positionId',
                },
                {
                    title: () => {
                        return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>Dispositivo</div>
                    },
                    align: 'center',
                    dataIndex: 'deviceId',
                },
                {
                    title: () => {
                        return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>Placa</div>
                    },
                    align: 'center',
                    dataIndex: 'plate',
                },
                {
                    title: () => {
                        return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>Data</div>
                    },
                    align: 'center',
                    dataIndex: 'date',
                    sorter: (a, b) => a.date.length - b.date.length,
                    sortDirections: ['descend', 'ascend'],
                    render: (text) => moment(text).format('DD/MM/YYYY HH:mm:ss '),
                },
                {
                    title: () => {
                        return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>Latitude</div>
                    },
                    align: 'center',
                    dataIndex: 'latitude',
                    sorter: (a, b) => a.latitude - b.latitude,
                    sortDirections: ['descend', 'ascend']
                },
                {
                    title: () => {
                        return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>Longitude</div>
                    },
                    align: 'center',
                    dataIndex: 'longitude',
                    sorter: (a, b) => a.longitude - b.longitude,
                    sortDirections: ['descend', 'ascend']
                },
                {
                    title: () => {
                        return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>Endereço</div>
                    },
                    align: 'center',
                    dataIndex: 'address',
                    ...this.tableSearch.getColumnSearchProps('address', "Endereços"),

                },
                {
                    title: () => {
                        return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>Ignição</div>
                    },
                    align: 'center',
                    dataIndex: 'ignition',
                    filters: [
                        {
                            text: 'ON',
                            value: 'ON',
                        },
                        {
                            text: 'OFF',
                            value: 'OFF',
                        },
                    ],
                    onFilter: (value, record) => record.ignition.indexOf(value) === 0,
                },
                {
                    title: () => {
                        return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>Odômetro</div>
                    },
                    align: 'center',
                    dataIndex: 'odometer',
                    sorter: (a, b) => a.odometer - b.odometer,
                    sortDirections: ['descend', 'ascend']
                },
                {
                    title: () => {
                        return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>Horímetro [hh:mm]</div>
                    },
                    align: 'center',
                    dataIndex: 'horimeter',
                    sorter: (a, b) => a.horimeter - b.horimeter,
                    sortDirections: ['descend', 'ascend'],
                    render: (text) => {
                        const hours = Math.floor(text / 60);
                        const minutes = Math.floor(text % 60);
                        return `${hours}:${minutes.toString().padStart(2, '0')}`;
                    },
                },
                {
                    title: () => {
                        return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>Bateria Principal [V]</div>
                    },
                    align: 'center',
                    dataIndex: 'mainBattery',
                    sorter: (a, b) => a.mainBattery - b.mainBattery,
                    sortDirections: ['descend', 'ascend']
                },
                {
                    title: () => {
                        return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>Input 1</div>
                    },
                    align: 'center',
                    dataIndex: 'input1',
                    sorter: (a, b) => a.input1 - b.input1,
                    sortDirections: ['descend', 'ascend']
                },
                {
                    title: () => {
                        return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>Input 2</div>
                    },
                    align: 'center',
                    dataIndex: 'input2',
                    sorter: (a, b) => a.input2 - b.input2,
                    sortDirections: ['descend', 'ascend']
                },
                {
                    title: () => {
                        return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>output 1</div>
                    },
                    align: 'center',
                    dataIndex: 'output1',
                    sorter: (a, b) => a.output1 - b.output1,
                    sortDirections: ['descend', 'ascend']
                },
                {
                    title: () => {
                        return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>output 2</div>
                    },
                    align: 'center',
                    dataIndex: 'output2',
                    sorter: (a, b) => a.output2 - b.output2,
                    sortDirections: ['descend', 'ascend']
                },
                {
                    title: () => {
                        return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>RS 232</div>
                    },
                    align: 'center',
                    dataIndex: 'rs232',
                    sorter: (a, b) => a.rs232 - b.rs232,
                    sortDirections: ['descend', 'ascend']
                }
            ];
        }


        /**
         * Table Pagination config
         */
        const paginationConfig = {
            defaultPageSize: this.state.tablePageSize,
            total: this.state.totalRegisters,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            onChange: (page, pageSize) => {
                this.setState({
                    tablePageSize: pageSize,
                    currentPage: page
                });


                const startDate = typeof this.state.startDate === 'string' ? this.state.startDate : this.state.startDate.format("YYYY-MM-DD");
                const endDate = typeof this.state.endDate === 'string' ? this.state.endDate : this.state.endDate.format("YYYY-MM-DD");
                const item = StorageService.getItem("plateName");
                this.getData(startDate, endDate, item, pageSize, page);
            },
        }

        const paginationTable = this.state.totalRegisters === 0 ? false : paginationConfig;
        return (
            <>
                <MgmtLayout>
                    <Row>
                        <Col span={24}>
                            <Card title="Histórico de Posições" style={{ height: '100%', paddingLeft: 5, paddingRight: 5, paddingBottom: 5, paddingTop: 5 }}>
                                <Row>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>

                                        <Select
                                            showSearch
                                            filterOption={(input, option) =>
                                                option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                            filterSort={(optionA, optionB) =>
                                                optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())
                                            }
                                            onChange={(e, opt) => {

                                                this.setState({ plateName: e, currentPage: 1, clientName: opt.client, positions: [] });

                                                StorageService.addItem("plateName", e);

                                            }}
                                            placeholder="Pesquisar por placa"
                                            options={this.state.plates ? this.state.plates : null}
                                            style={{ marginBottom: '10px', width: '95%' }}
                                        />
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={8} style={{ display: 'flex', alignItems: 'flex-start' }}>

                                        <DatePicker
                                            format={{
                                                format: 'YYYY-MM-DD 00:00:00',
                                                type: 'mask',
                                            }}
                                            placeholder='Data Inicial'
                                            onChange={(date, dateString) => {
                                                this.setState({
                                                    startDate: dateString,
                                                });
                                            }}
                                            style={{ width: '50%' }}
                                        />
                                        <DatePicker
                                            format={{
                                                format: 'YYYY-MM-DD 23:59:59',
                                                type: 'mask',
                                            }}
                                            placeholder='Data Final'
                                            onChange={(date, dateString) => {
                                                this.setState({
                                                    endDate: dateString,
                                                });
                                                //
                                            }}
                                            style={{ width: '50%', marginLeft: '5%' }}
                                        />

                                    </Col>
                                    <Col span={24}>
                                        <Button
                                            className='successButton'
                                            type='primary'
                                            shape="round"
                                            style={{ float: 'right' }}
                                        >
                                            <CSVLink
                                                data={this.state.positions}
                                                separator={";"}
                                                filename={"position_history.csv"}
                                            >
                                                Download CSV
                                            </CSVLink>
                                        </Button>
                                        <Button
                                            type="primary"
                                            shape="round"
                                            style={{ marginRight: '5px', float: 'right' }}
                                            onClick={() => {
                                                this.delayOnChangeSearch(StorageService.getItem("plateName"), 1);
                                            }}
                                        >
                                            Gerar Relatório
                                        </Button>

                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={24} style={{ marginTop: "15px" }}>
                                        <Table
                                            style={{ height: '100%' }}
                                            scroll={{ x: "max-content" }}
                                            loading={this.state.showLoading}
                                            columns={columns}
                                            dataSource={this.state.positions}
                                            size='small'
                                            pagination={paginationTable}
                                            rowClassName={(record, index) => index % 2 === 0 ? 'row-dark ' : 'row-light'}
                                        />
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                    </Row>


                </MgmtLayout>
            </>
        );
    }
}

export default withRouter(MgmtPositions);